import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicStyleLoaderService } from '../../utilities/dynamic-style-loader';


@Component({
    selector: 'my-account-dob-edit',
    templateUrl: './dob-edit.component.html',
    styleUrls: [],
    standalone: false
})
export class DobEditComponent implements OnInit {
  
  dialogData:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dynamicStyleLoader: DynamicStyleLoaderService) {
    this.dialogData = data.parentInstance;
   }  

  ngOnInit(): void {
    this.dynamicStyleLoader.focusCloseButton('dob-edit-close-mobile','dob-edit-close');  
  }
}